import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);

  const runSearch = async (query) => {
    if (!query.trim()) return;
    const { data } = await api.get("/articles", { params: { q: query, limit: 24 } });
    setResults(data.items);
    setSearched(true);
  };

  const submit = (e) => {
    e.preventDefault();
    setParams({ q });
    runSearch(q);
  };

  useEffect(() => {
    const initial = params.get("q");
    if (initial) runSearch(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="search-page">
      <SEO title="Търсене" description="Търсене на статии в Metri.bg" />
      <h1 className="font-serif text-3xl font-bold text-[#10243A] mb-6">Търсене</h1>
      <form onSubmit={submit} className="relative mb-10">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#66717B]" />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Търси статии по ключова дума..."
          className="pl-11 h-12 text-lg"
          data-testid="search-input"
        />
      </form>
      <div className="space-y-6" data-testid="search-results">
        {results.map((a) => <ArticleCard key={a.id} article={a} variant="grid" />)}
      </div>
      {searched && results.length === 0 && <p className="text-[#66717B]">Няма намерени резултати за &quot;{q}&quot;.</p>}
    </div>
  );
}
